import { Breadcrumb, Button, Card, Col, Divider, Grid, notification, Row, Space, Spin, Statistic, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { GlassButton } from '../glass';
import { useDashboardCalculationMutation } from '../slices/zerodhaApiSlice';
import { setCalculations } from '../slices/dashboardSlice';
import { ArrowDownOutlined, ArrowUpOutlined, HistoryOutlined, LockOutlined, SyncOutlined, UploadOutlined } from '@ant-design/icons';
import TradeLogsTradeTable from './Usercomp/TradeLogsTradeTable';
import DateRange from './global/comp/DateRange';
import './css/tradeStats.css';
import { useGetCecmasMutation, useGetSubMutation } from '../slices/usersApiSlice';

const TradeLogsScreen = () => {
  const [api, contextHolder] = notification.useNotification();
  const [getmySub, { isLoading: ismyLoading }] = useGetSubMutation();
  const [currentPlan, setCurrentPlan] = useState(null);
  const [gcemas, { isLoading: isLoading }] = useGetCecmasMutation();
  const [admin, setAdmin] = useState(null);
  const { Text, Title } = Typography;
  const newDate = new Date();

  const { date } = useSelector((state) => state.date);
  const { dashboard } = useSelector((state) => state.dashboard);
  const { darkmode } = useSelector((state) => state.darkmode);


  const [dashboardCalculation, { isLoading: isCalculationLoading }] = useDashboardCalculationMutation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const getCalculations = async (startDate, endDate) => {
    try {
      const res = await dashboardCalculation({ startDate, endDate }).unwrap();
      dispatch(setCalculations({ ...res }));
    } catch (err) {
      console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  }

  const getMysub = async () => {
    try {
      const res = await getmySub().unwrap();
      setCurrentPlan(res.subscription);
      // console.log(res.subscription);
    } catch (err) {
      console.log(err);
    }
  };

  const getmas = async () => {
    try {
      const res = await gcemas().unwrap();
      setAdmin(res.user);
    } catch (err) {
      console.log(err);
    }

  }
  useEffect(() => {
    getMysub();
    getmas();
  }, []);

  useEffect(() => {
    getCalculations(date.startDate, date.endDate);
  }, [date])

  const pnlWin = Number(dashboard?.netrealisedpnl) > 0;
  const tradeWinOk = dashboard?.winpercent != null && Number(dashboard.winpercent) >= 50;
  const factorWin = dashboard?.factor === "Perfect Profit" || Number(dashboard?.factor) > 1;
  const dayWinOk = dashboard?.daywinp != null && Number(dashboard.daywinp) >= 50;
  const unlocked = currentPlan != null && admin != null && ((currentPlan.plan_id != "68a2df20b2bdf6c04cb5295b" && currentPlan.status == "active") || admin == true);
  const tone = (ok) => (ok ? 'stat-win' : 'stat-loss');

  return (
    <>
      {contextHolder}
      {/* <div className="gd-head">
        <h1>Trade Log</h1>
        <GlassButton variant="primary" onClick={() => navigate('/ImportTrades')}>+ Log Trade</GlassButton>
      </div> */}
      {/* <Row style={{ padding: "20px", backgroundColor: darkmode ? "#141414" : "white", borderRadius: "5px" }}>
        <Col flex={"auto"}>
          <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'Trade Logs' }]} style={{ marginBottom: "5px" }} />
          <Space direction="horizontal" style={{ marginBottom: "10px" }}>
            {!screens.lg ? (<DateRange />) : (<></>)}
          </Space>
        </Col> */}
        {/* <Col flex={"none"}>
          <Space direction={!screens.lg ? "vertical" : "horizontal"} style={{ marginBottom: "10px" }}>
            <Text type="secondary"><SyncOutlined /> Last import was: {newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate()}</Text>
            <Button type='primary' ghost><UploadOutlined /> Import Trades</Button>
          </Space>
        </Col> */}
      {/* </Row> */}
      <Divider />
      <Row gutter={[16, 24]} style={{ marginBottom: "10px" }}>
        <Col md={6} xs={24}>
          <Card bordered={false} className={`card_hover stat-card ${tone(pnlWin)}`} >
            <Statistic
              title={"Realised (P&L)"}
              loading={isCalculationLoading}
              value={dashboard.netrealisedpnl ? Number(dashboard.netrealisedpnl).toFixed(2) : 0}
              precision={2}
              valueStyle={{
                color: 'inherit',
              }}
              formatter={(value) => new Intl.NumberFormat('en-IN').format(value)}
              prefix={dashboard != null && dashboard.netrealisedpnl > 0 ? <> <ArrowUpOutlined  /> ₹ </> : <><ArrowDownOutlined  /> ₹ </>}
            />
          </Card>
        </Col>
        <Col md={6} xs={24}>
          <Card bordered={false} className={`card_hover stat-card ${tone(tradeWinOk)}`} >
            <Statistic
              loading={isCalculationLoading}
              title={"Trade Win %"}
              value={dashboard.winpercent != null ? dashboard.winpercent : 0}
              precision={2}
              valueStyle={{
                color: 'inherit',
              }}
              prefix={(dashboard.winpercent != null && dashboard.winpercent >= 50) ? <ArrowUpOutlined  /> : <ArrowDownOutlined  />}
              suffix="%"
            />
          </Card>
        </Col>
        <Col md={6} xs={24}>
          <Card bordered={false} className={`card_hover stat-card ${unlocked ? tone(factorWin) : ''}`}>
            {currentPlan != null && admin != null ? (
              currentPlan.plan_id != "68a2df20b2bdf6c04cb5295b" && currentPlan.status == "active" || admin == true ?
                <Statistic
                  loading={isCalculationLoading}
                  title="Profit Factor"
                  value={dashboard != null && dashboard.factor != null ? dashboard.factor : "N/A"}
                  precision={2}
                  valueStyle={{
                    color: 'inherit',
                  }}
                  prefix={(dashboard != null && (dashboard.factor > 1 || dashboard.factor != null) && dashboard.factor == "Perfect Profit") ? <ArrowUpOutlined  /> : <ArrowDownOutlined  />}
                  suffix=""
                />
                :
                <Statistic
                  loading={isCalculationLoading}
                  title="Profit Factor"
                  value={"This feature is Premium"}
                  precision={2}
                  valueStyle={{
                    color: 'inherit',
                  }}
                  prefix={<LockOutlined />}

                />) : (
              <>
                Loadin Please wait... <Spin />
              </>
            )}
          </Card>
        </Col>
        <Col md={6} xs={24}>
          <Card bordered={false} className={`card_hover stat-card ${unlocked ? tone(dayWinOk) : ''}`}>
            {currentPlan != null && admin != null ? (
              currentPlan.plan_id != "68a2df20b2bdf6c04cb5295b" && currentPlan.status == "active" || admin == true ?
                <Statistic
                  loading={isCalculationLoading}
                  title="Day Win %"
                  value={dashboard != null && dashboard.daywinp != null ? dashboard.daywinp : 0}
                  precision={2}
                  valueStyle={{
                    color: 'inherit',
                  }}
                  prefix={(dashboard != null && dashboard.daywinp != null && dashboard.daywinp >= 50) ? <ArrowUpOutlined  /> : <ArrowDownOutlined  />}
                  suffix="%"
                />
                :
                <Statistic
                  loading={isCalculationLoading}
                  title="Day Win %"
                  value={"This feature is Premium"}
                  precision={2}
                  valueStyle={{
                    color: 'inherit',
                  }}
                  prefix={<LockOutlined />}

                />
            ) : (
              <>
                Loadin Please wait... <Spin />
              </>
            )}
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 24]} style={{ marginBottom: "10px" }}>
        <Col md={24} xs={24}>
          <TradeLogsTradeTable />
        </Col>
      </Row>
    </>
  )
}

export default TradeLogsScreen